<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  @if (row) {
    <app-page-detail-hero [auditStamp]="row"
      icon="pi pi-cog"
      [eyebrow]="title + ' Setup Value'"
      [title]="row.name"
      [subtitle]="row.code || 'No setup code'">
      <div tags>
        <p-tag [value]="row.isActive === false ? 'INACTIVE' : 'ACTIVE'" [severity]="statusSeverity(row.isActive === false ? 'INACTIVE' : 'ACTIVE')"></p-tag>
        <p-tag [value]="title" severity="secondary"></p-tag>
      </div>
      <div actions>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" [routerLink]="listRoute"></p-button>
        <p-button label="Edit" icon="pi pi-pencil" severity="info" [routerLink]="listRoute + '/edit/' + row.id" [queryParams]="editQuery()"></p-button>
      </div>
    </app-page-detail-hero>

    @if (type === 'WAREHOUSE') {
      <app-page-form-section icon="pi pi-warehouse" title="Warehouse Setup" [subtitle]="setupDescription">
        <div class="warehouse-detail-sections">
          <section>
            <h3>Identity</h3>
            <dl>
              <div><dt>Name</dt><dd>{{ row.name }}</dd></div>
              <div><dt>Code</dt><dd>{{ row.code || '-' }}</dd></div>
              <div><dt>Status</dt><dd>{{ row.isActive === false ? 'Inactive' : 'Active' }}</dd></div>
              <div><dt>Record ID</dt><dd>{{ row.id }}</dd></div>
            </dl>
          </section>
          <section>
            <h3>Location &amp; Region</h3>
            <dl>
              <div><dt>Linked Location</dt><dd>{{ row.locationName || (row.locationId ? 'Location #' + row.locationId : '-') }}</dd></div>
              <div><dt>Region</dt><dd>{{ relationshipLabel() }}</dd></div>
            </dl>
          </section>
          <section class="warehouse-custody-section">
            <h3>Ownership &amp; Supplier</h3>
            <dl>
              <div><dt>Ownership</dt><dd>{{ ownershipLabel(row) }}</dd></div>
              <div><dt>Supplier</dt><dd>{{ row.supplierClientName || '-' }}</dd></div>
              <div><dt>Supplier Warehouse</dt><dd>{{ row.supplierWarehouseName || '-' }}</dd></div>
            </dl>
          </section>
        </div>
      </app-page-form-section>
    } @else {
    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-form-section icon="pi pi-info-circle" title="Setup Details" [subtitle]="setupDescription">
      <div class="warehousing-detail-list">
        <div><span>Name</span><strong>{{ row.name }}</strong></div>
        <div><span>Type</span><strong>{{ title }}</strong></div>
        <div><span>Code</span><strong>{{ row.code || '-' }}</strong></div>
        @if (showRelationship) {
          <div><span>Relationship</span><strong>{{ relationshipLabel() }}</strong></div>
        }
        @if (showLocation) {
          <div><span>Location</span><strong>{{ row.locationName || (row.locationId ? 'Location #' + row.locationId : '-') }}</strong></div>
        }
        @if (showSupplier) {
          <div><span>Supplier</span><strong>{{ row.supplierClientName || '-' }}</strong></div>
          <div><span>Supplier Warehouse</span><strong>{{ row.supplierWarehouseName || '-' }}</strong></div>
          <div><span>Ownership</span><strong>{{ ownershipLabel(row) }}</strong></div>
        }
        @if (showDefaultWarehouse) {
          <div><span>Default Warehouse</span><strong>{{ defaultWarehouseLabel() }}</strong></div>
        }
        <div><span>Record ID</span><strong>{{ row.id }}</strong></div>
      </div>
    </app-page-form-section>
    }

    @if (showRegionMappings) {
      <app-page-form-section icon="pi pi-map-marker" title="Covered Cities" subtitle="Country and city coverage assigned to this region.">
        <div class="warehousing-detail-list">
          <div><span>Total Coverage</span><strong>{{ row.regionMappings?.length }}</strong></div>
          @for (mapping of row.regionMappings; track mapping.cityId; let i = $index) {
            <div><span>Coverage {{ i + 1 }}</span><strong>{{ regionMappingLabel(i) }}</strong></div>
          }
        </div>
      </app-page-form-section>
    }
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Setup value not found</strong>
      <span>The selected setup value could not be loaded.</span>
    </div>
  }
</app-page-shell>
